import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

import styles from './ConnectPop.module.css';
import pageStylePops from './pageStylePops.module.css';

import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import { theMenuItems } from '../FAKEDB/fakes'
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsSpecialPages from '../Connections/_Utils/utilsSpecialPages';
import MyFunctions from '../Functions/MyFunctions';
import PopUpClearComp from './PopUpClearComp';
import ConnectCodeCheck from './ConnectCodeCheck';
import { UserContext } from '../Contexts/User_Context';

const WelcomBackPop = (props) => {
    const navigate = useNavigate();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);

    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);
    const [pageDetails, setPageDetails] = useState();
    const [thePopUp, setThePopUp] = useState();

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsSpecialPages.getStaticPageByName("WelcomePop")
            setPageDetails(pg);
        }
        getPageDetalis();

        // Set up the timer to close the pop-up after 5 seconds
        const timer = setTimeout(() => {
            closeIt();
        }, 5000);

        // Clear the timer if the component unmounts
        return () => clearTimeout(timer);
    }, [])

    useEffect(() => {
    }, [mobiOrNot]);

    const closeIt = () => {
        props.closeMeFuc();
    }

    return (
        <div className={`${pageStylePops.topPlace} regularPoint`}>
            {pageDetails && <>
                <div className={pageStylePops.topPlaceWrap}>
                    <div className={pageStylePops.TopImg}>
                        <img src={`${ConnUrls.servMediasUrl}${!mobiOrNot ? pageDetails.PageTopImage : pageDetails.PageTopImageMobi}`}
                            className={pageStylePops.TopImg} alt={pageDetails.pageName || "ברוך שובך"} />
                    </div>
                </div>
                <div className={`${pageStylePops.topPlace} regularPoint`}>
                    <p className={`${pageStylePops.headBig} fullRow`}>היי {user.firstName},</p>
                    <p className={`${pageStylePops.headBig} inColorgoldLine`}>{props.theHelloTxt}</p>
                </div>

                <div className={`${pageStylePops.mainWrap}`}>
                    <div className={pageStylePops.contWrap}>
                        <div className={pageStylePops.btnGo}>
                            <button className={`${pageStylePops.contactGo} pointing`} value="המשך" onClick={closeIt}>המשך</button>
                        </div>
                    </div>
                </div>
                {thePopUp}
            </>}
        </div>
    );
}

export default WelcomBackPop;